<template>
  <v-tooltip right :content-class="tooltipClass">
    <template v-slot:activator="{ on, attrs }">
      <span @click="copy" style="cursor: pointer" v-bind="attrs" v-on="on"
        ><v-icon style="font-size: 20px" class="pb-1 mr-4" :color="iconColor">
          fas fa-copy</v-icon
        ></span
      >
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "primary",
      required: false
    },
    tooltipClass: {
      type: String,
      default: "portal-tooltip",
      required: false
    },
    copiedText: {
      type: String,
      default: "",
      required: false
    },
    valueToCopy: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      text: this.$t("copy")
    };
  },
  methods: {
    async copy() {
      let self = this;
      await navigator.clipboard.writeText(self.valueToCopy);
      self.text = self.copiedText;
      setTimeout(function () {
        self.text = self.$t("copy");
      }, 1000);
    }
  }
};
</script>
